import loaderStyle from './loader.module.css';

export function Loader() {
  return (
    <div className={loaderStyle.spinner}>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
}
